import React from 'react'

import s from './styles.module.scss'

interface IHouseSearchResultsFiltersLayoutProps {
  filters: React.ReactNode
}

export const HouseSearchResultsFiltersLayout = ({
  filters,
}: IHouseSearchResultsFiltersLayoutProps) => {
  return <div className={s.container}>{filters}</div>
}
